import axios from 'axios';
import {loginreq, req} from './axiosFun';

// 登录接口
export const login = (params) => {
  return loginreq("post", "/pc/apps/login", params)
};
export const getCodes = (params) => {
  return loginreq("post", "/pc/apps/sms", params)
};
// 退出接口
export const logout = () => {
  return axios.delete("/pc/apps/logout").then(res => res.data)
};

//首页相关信息获取
export const home = () => {
  return req("post", "/pc/home")
};

//基本设置
export const basicSetting = (params) => {
  return req("post", "/pc/apps/setting", params)
};

export const secret = (params) => {
  return req("post", "/pc/protocal/secret", params)
};
//隐私
export const agreements = (params) => {
  return req("post", "/pc/protocal/agreement", params)
};

//广告
export const ad = (params) => {
  return req("get", "/pc/apps/ad", params)
};
export const adSave = (params) => {
  return req("post", "/pc/ad/save", params)
};
//管理员
export const manager = (params) => {
  return req("post", "/pc/auth/index", params)
};
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => {
  return axios.post("/pc/auth/menu", params)
};

//添加/修改管理员白名单
export const allWhite = (params) => {
  return req("post", "/pc/manager/all", params)
};
//添加/修改管理员白名单
export const saveWhite = (params) => {
  return req("post", "/pc/manager/save", params)
};
//添加/修改管理员白名单
export const deleteWhite = (params) => {
  return req("post", "/pc/manager/destroy", params)
};
export const userGroup = () => {
  return req("post", "/pc/auth/userGroup")
};
export const saveManager = (params) => {
  return req("post", "/pc/auth/saveAdmin", params)
};
export const notice = (params) => {
  return req("post", "/pc/systemInfo", params)
};
export const noticeSave = (params) => {
  return req("post", "/pc/systemInfo/save", params)
};
export const noticeDelete = (params) => {
  return req("post", "/pc/systemInfo/destroy", params)
};
export const allMenu = (params) => {
  return req("post", "/pc/auth/menus", params)
};
export const menus = (params) => {
  return req("post", "/pc/auth/menu", params)
};
export const menuSave = (params) => {
  return req("post", "/pc/auth/menuSave", params)
};
export const menuDelete = (params) => {
  return req("post", "/pc/auth/menuDelete", params)
};
export const selectedMenu = (params) => {
  return req("post", "/pc/auth/selectedMenu", params)
};
export const userMenuSave = (params) => {
  return req("post", "/pc/auth/saveMenu", params)
};
export const white = () => {
  return req("post", "/pc/manager")
};
export const map = () => {
  return req("post", "/pc/devices/map")
};
export const tasks = (params) => {
  return req("post", "/pc/device/tasks", params)
};
export const saveTask = (params) => {
  return req("post", "/pc/device/taskSave", params)
};
export const deleteTask = (params) => {
  return req("post", "/pc/device/deleteTask", params)
};
export const deviceAdd = (params) => {
  return req("post", "/pc/device/add", params)
};
export const deviceDelete = (params) => {
  return req("post", "/pc/device/deleteDevice", params)
};
export const devices = (params) => {
  return req("post", "/pc/device/devices", params)
};
export const batchAutos = (params) => {
  return req("post", "/pc/device/multiAction", params)
};
export const batchDelete = (params) => {
  return req("post", "/pc/device/batchDelete", params)
};
export const batchHands = (params) => {
  return req("post", "/pc/device/multiAction", params)
};
export const batchLocks = (params) => {
  return req("post", "/pc/device/multiAction", params)
};
export const batchMoves = (params) => {
  return req("post", "/pc/device/batchMove", params)
};
export const batchPlays = (params) => {
  return req("post", "/pc/device/multiAction", params)
};
export const batchStops = (params) => {
  return req("post", "/pc/device/multiAction", params)
};
export const batchUnLocks = (params) => {
  return req("post", "/pc/device/multiAction", params)
};
export const batchEdits = (params) => {
  return req("post", "/pc/device/batchParams", params)
};
export const deviceDetailParam = (params) => {
  return req("post", "/pc/device/deviceParam", params)
};
export const unusedDevices = (params) => {
  return req("post", "/pc/device/unuse", params)
};
export const deleteCurrentDevice = (params) => {
  return req("post", "/pc/device/delete", params)
};
export const deleteDevices = (params) => {
  return req("post", "/pc/device/deleteDevices", params)
};
export const groupsDetail = (params) => {
  return req("post", "/pc/device/groupsDetail", params)
};
export const groupDevice = (params) => {
  return req("post", "/pc/device/groupDevice", params)
};
export const groups = (params) => {
  return req("post", "/pc/device/groups", params)
};
export const groupSave = (params) => {
  return req("post", "/pc/device/updateGroup", params)
};
export const groupSaveAction = (params) => {
  return req("post", "/pc/device/updateGroupAction", params)
};
export const groupDelete = (params) => {
  return req("post", "/pc/device/deleteGroup", params)
};
export const saveWeather = (params) => {
  return req("post", "/pc/devices/saveWeather", params)
};

export const deleteWeather = (params) => {
  return req("post", "/pc/devices/deleteWeather", params)
};

export const saveWeatherMemo = (params) => {
  return req("post", "/pc/devices/saveWeatherMemo", params)
};
export const saveWeatherMove = (params) => {
  return req("post", "/pc/devices/moveWeather", params)
};


export const agreement = () => {
  return req("post", "/pc/user/agreement")
};
export const course = (params) => {
  return req("post", "/pc/user/teachList", params)
};
export const alarm = (params) => {
  return req("post", "/pc/alarm", params)
};
export const current = (params) => {
  return req("post", "/pc/device/current", params)
};
export const reset = (params) => {
  return req("post", "/pc/device/reset", params)
};
export const alarmDelete = (params) => {
  return req("post", "/pc/alarm/deleteAlarm", params)
};
//查看操作日志列表
export const logs = (params) => {
  return req("post", "/pc/logs", params)
};
//查看用户列表
export const users = (params) => {
  return req("post", "/pc/user/users", params)
};
export const updatePhone = (params) => {
  return req("post", "/pc/user/bindPhone", params)
};
//设置角色
export const setUserRole = (params) => {
  return req("post", "/pc/wechat/setRole", params)
};
//设置角色
export const lockUserDevice = (params) => {
  return req("post", "/pc/devices/lockDevice", params)
};
//查看操作员
export const wechatManager = (params) => {
  return req("post", "/pc/wechat/manager", params)
};
//保存管理员
export const addUser = (params) => {
  return req("post", "/pc/user/addUser", params)
};
//删除管理员
export const deleteUser = (params) => {
  return req("post", "/pc/user/deleteUser", params)
};
//查看操作员
export const searchOperator = (params) => {
  return req("post", "/pc/wechat/operators", params)
};

//查看维修保养
export const repairs = (params) => {
  return req("post", "/pc/history", params)
};
//提交维修保养
export const saveRepair = (params) => {
  return req("post", "/pc/submit", params)
};
//删除维修保养
export const deleteRepairs = (params) => {
  return req("post", "/pc/deleteRepair", params)
};

//检查用户权限
export const checkAuth = (params) => {
  return req("post", "/pc/user/checkAuths", params)
};











// WEBPACK FOOTER //
// ./src/api/userMG.js